export interface PciInformation {
    PCI: number;
    ECI: string;
    cellType?: 'ECI' | 'NCI';
    CustomizeName: string;
    Location: string;
};